import store from '@/store'
import { liveStats } from '@/mqtt/liveStats'
import { resourcesSubscriber } from '@/mqtt/resources'
import kvSyncSubscriber from '@/mqtt/kvSync'
import mqttClient from '@/mqtt/mqtt.client'

function init() {
  liveStats.connect()
  resourcesSubscriber.init()
  kvSyncSubscriber.init()

  // Counting is published non-retained, so updates sent while the connection was down never arrive.
  // Spread over 30s: a broker node restart reconnects every audience member on it at once.
  mqttClient.on('connect', () => {
    store.dispatch('counting/reseed', { maxDelayMs: 30000 }).catch(() => {})
  })
}

export default { init }
